import {Endpoints} from '../../../../../globals/api/endpoints';

export class LayerManagerEndpoints extends Endpoints {

  private static readonly LAYER_MANAGERS = LayerManagerEndpoints.VIEWER + '/layer-manager';
  public static readonly LAYER_MANAGER = LayerManagerEndpoints.LAYER_MANAGERS + '/' + LayerManagerEndpoints.PROJECT_ID;
  public static readonly LAYER_MANAGER_PREVIEW = LayerManagerEndpoints.LAYER_MANAGERS + '/' + LayerManagerEndpoints.VERSION_ID + '/preview';
}
